import koreanFontUrl from '../assets/NanumGothic-Regular.ttf.gz?url';
import { decodePdfFont } from './pdf-font.js';

async function loadRuntime() {
  const [pdfLib, { default: fontkit }, response] = await Promise.all([import('pdf-lib'), import('@pdf-lib/fontkit'), fetch(koreanFontUrl)]);
  if (!response.ok) throw new Error('PDF 한글 글꼴을 준비하지 못했어요. 연결을 확인하고 다시 시도해 주세요.');
  const fontBytes = decodePdfFont(new Uint8Array(await response.arrayBuffer()));
  return { ...pdfLib, fontkit, fontBytes };
}
let runtime: ReturnType<typeof loadRuntime> | undefined;
/** Prepare assets before save is enabled; actual document generation has no network I/O. */
export function preparePdfRuntime() {
  return runtime ??= loadRuntime().catch((error) => { runtime = undefined; throw error; });
}
